// frontend/src/handshake.js
import { exchangeEST } from "./services/api";

let exchanged = false;

export function installEmbedHandshake() {
  if (exchanged) return;
  window.addEventListener("message", async (event) => {
    try {
      // Expect a message like: { type: 'careers.est', est: '...', ts: 169...' }
      const data = event?.data || {};
      if (data?.type !== "careers.est" || !data?.est) return;

      if (exchanged) return;
      exchanged = true;

      await exchangeEST(data.est, event.origin);
      // Optional: notify parent that we’re ready
      event.source?.postMessage({ type: "careers.ready" }, event.origin);
    } catch (e) {
      console.error("EST exchange failed:", e);
    }
  });
}
